import React, { useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";
import { toast } from "sonner";

export default function Bracelet() {
  const [code, setCode] = useState("");
  const [bracelet, setBracelet] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (c) => {
    setLoading(true);
    try {
      const { data } = await api.get(`/bracelet/${encodeURIComponent(c)}`);
      setBracelet(data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  const recharge = async (amount) => {
    if (!bracelet) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/bracelet/${encodeURIComponent(bracelet.code)}/recharge`, { amount });
      setBracelet(data);
      toast.success(`Recharge de CHF ${amount} confirmée`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-black gradient-text inline-block">Bracelet cashless</h1>
      <p className="text-neutral-400 mt-2">Consultez le solde de votre bracelet et rechargez-le en un clic.</p>

      <div className="card-hsg p-6 mt-6">
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-neutral-500">Code du bracelet</span>
          <div className="flex gap-2 mt-1">
            <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="HSG-XXXX" className="flex-1 bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2 uppercase" data-testid="bracelet-code-input" />
            <button disabled={!code || loading} onClick={() => load(code)} className="brand-gradient-btn px-6 py-2 rounded-lg" data-testid="bracelet-lookup">Consulter</button>
          </div>
        </label>
      </div>

      {loading && <Loader />}

      {bracelet && !loading && (
        <>
          <div className="card-hsg p-6 mt-4 text-center">
            <div className="text-neutral-400 text-sm">Solde du bracelet {bracelet.code}</div>
            <div className="text-5xl font-black mt-2 gradient-text inline-block">CHF {Number(bracelet.balance).toFixed(2)}</div>
          </div>

          <div className="card-hsg p-6 mt-4">
            <div className="font-bold mb-3">⚡ Recharge rapide</div>
            <div className="grid grid-cols-3 gap-2">
              {(bracelet.amounts || [20, 50, 100]).map((a) => (
                <button key={a} onClick={() => recharge(a)} className="card-hsg p-4 font-bold hover:bg-neutral-800" data-testid={`recharge-${a}`}>+ CHF {a}</button>
              ))}
            </div>
          </div>

          {(bracelet.transactions || []).length > 0 && (
            <div className="card-hsg p-6 mt-4">
              <div className="font-bold mb-3">Historique</div>
              <div className="space-y-2 max-h-64 overflow-y-auto scrollbar-thin">
                {bracelet.transactions.map((t, i) => (
                  <div key={i} className="flex justify-between text-sm border-b border-neutral-800 pb-2">
                    <div>
                      <div className="font-semibold capitalize">{t.type === "recharge" ? "💰 Recharge" : t.type}</div>
                      <div className="text-neutral-500 text-xs">{new Date(t.created_at).toLocaleString("fr-CH")}</div>
                    </div>
                    <div className="font-bold text-[#A1C861]">+ CHF {Number(t.amount).toFixed(2)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
